import type { UrlTileChromeRenderer, UrlTilePayload, UrlTileRenderContext } from '../url-tiles';
import type { ChatContext } from './chat-context-types';
import { TileWithChat } from './TileWithChat';

export const createChatUrlTileChrome = ({
    getChatContext,
    tileTypes,
}: {
    readonly getChatContext?: (payload: UrlTilePayload, context: UrlTileRenderContext) => ChatContext | undefined;
    readonly tileTypes: readonly string[];
}): UrlTileChromeRenderer => {
    const chatEnabledTileTypes = new Set(tileTypes);

    return ({ content, context, tile }) => {
        if (!chatEnabledTileTypes.has(tile.definition.type)) {
            return content;
        }

        return (
            <TileWithChat chatContext={getChatContext?.(tile.payload, context)} tileId={tile.slotKey}>
                {content}
            </TileWithChat>
        );
    };
};
